import {
  createWhitelistedIpAddress as requestCreateWhitelistedIpAddress,
  deleteWhitelistedIpAddress as requestDeleteWhitelistedIpAddress,
  getWhitelistedIpAddresses
} from "@utils/aegean_api_handler";

import { notify } from "@utils/notifications";

export const GET_WHITELISTED_IP_ADDRESSES_REQUEST = "GET_WHITELISTED_IP_ADDRESSES_REQUEST";
export const GET_WHITELISTED_IP_ADDRESSES_SUCCESS = "GET_WHITELISTED_IP_ADDRESSES_SUCCESS";
export const GET_WHITELISTED_IP_ADDRESSES_ERROR = "GET_WHITELISTED_IP_ADDRESSES_ERROR";

export const CREATE_WHITELISTED_IP_ADDRESSES_REQUEST = "CREATE_WHITELISTED_IP_ADDRESSES_REQUEST";
export const CREATE_WHITELISTED_IP_ADDRESSES_SUCCESS = "CREATE_WHITELISTED_IP_ADDRESSES_SUCCESS";
export const CREATE_WHITELISTED_IP_ADDRESSES_ERROR = "CREATE_WHITELISTED_IP_ADDRESSES_ERROR";

export const DELETE_WHITELISTED_IP_ADDRESSES_REQUEST = "DELETE_WHITELISTED_IP_ADDRESSES_REQUEST";
export const DELETE_WHITELISTED_IP_ADDRESSES_SUCCESS = "DELETE_WHITELISTED_IP_ADDRESSES_SUCCESS";
export const DELETE_WHITELISTED_IP_ADDRESSES_ERROR = "DELETE_WHITELISTED_IP_ADDRESSES_ERROR";

export const fetchWhitelistedIpAddresses = () => (dispatch) => {
  dispatch({ type: GET_WHITELISTED_IP_ADDRESSES_REQUEST });

  return getWhitelistedIpAddresses()
    .then(({ response }) => {
      dispatch({
        type: GET_WHITELISTED_IP_ADDRESSES_SUCCESS,
        data: response
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_WHITELISTED_IP_ADDRESSES_ERROR,
        error
      });
    });
};

export const createWhitelistedIpAddress = (organization_id, address) => (dispatch) => {
  dispatch({ type: CREATE_WHITELISTED_IP_ADDRESSES_REQUEST });

  return requestCreateWhitelistedIpAddress(organization_id, address)
    .then(({ response: { message, ipAddress } }) => {
      notify(message);
      dispatch({
        type: CREATE_WHITELISTED_IP_ADDRESSES_SUCCESS,
        data: ipAddress
      });
    })
    .catch((error) => {
      dispatch({
        type: CREATE_WHITELISTED_IP_ADDRESSES_ERROR,
        error
      });
    });
};

export const deleteWhitelistedIpAddress = ipAddressId => (dispatch) => {
  dispatch({ type: DELETE_WHITELISTED_IP_ADDRESSES_REQUEST });

  return requestDeleteWhitelistedIpAddress(ipAddressId)
    .then(({ response: { message, ipAddress } }) => {
      notify(message);
      dispatch({
        type: DELETE_WHITELISTED_IP_ADDRESSES_SUCCESS,
        data: ipAddress
      });
    })
    .catch((error) => {
      dispatch({
        type: DELETE_WHITELISTED_IP_ADDRESSES_ERROR,
        error
      });
    });
};
